// src/hooks/useSubscription.ts
import { DISABLE_AUTH } from '../config/flags';

export function useSubscription() {
  if (DISABLE_AUTH) {
    return {
      isLoading: false,
      hasActiveSubscription: () => true,
      plan: 'cosmic' as const,
      isTrial: true,
      refresh: async () => {},
    };
  }

  // fallback default when real logic is enabled
  return {
    isLoading: false,
    hasActiveSubscription: () => false,
    plan: 'trial' as const,
    isTrial: true,
    refresh: async () => {},
  };
}
